// Lista compartida de partners (usada por TheHeader y ThePartners)
// `service` es la categoría/servicio que aparece como label principal en el menú desplegable.
// `href` vacío = el logo se muestra sin enlace (sitio inactivo).
// Si actualizas un partner, edita este archivo y rebuild.
export const PARTNERS = [
  { file: 'socios/bandera.png',     name: 'Mundo Bandera',  service: 'Banderas y Estandartes',     href: 'https://www.mundobandera.com.mx/' },
  { file: 'socios/desing.png',      name: 'Nahui Design',   service: 'Artículos Personalizados',   href: 'https://nahuidesign.com.mx/' },
  { file: 'socios/logojoom.png',    name: 'Joom Capital',   service: 'Seguros',                    href: 'https://joomcapital.com.mx/' },
  { file: 'socios/logojobman.png',  name: 'Jobman',         service: 'Inmobiliaria',               href: '' },
  { file: 'socios/recc.png',        name: 'RECC',           service: 'Asesoría Legal Inmobiliaria', href: 'https://recc.com.mx/' },
  { file: 'socios/adnexis.svg',     name: 'Adnexis',        service: 'Tecnología con Capital Humano', href: 'https://adnexis.com.mx/' },
];
